import Auth from '../api/auth';

const parseErrorCode = error => {
  if (error?.response?.status === 402) {
    const accountId =
      error.response.config?.url?.match(/accounts\/(\d+)/)?.[1];
    if (accountId) {
      fetch(`/api/v1/accounts/${accountId}/subscription`)
        .then(res => res.json())
        .then(data => {
          if (data.plan_name) {
            window.location = `${window.dropechatConfig.billingUrl}/billing/checkout/${data.plan_name}`;
          }
        })
        .catch(() => {});
    }
  }
  return Promise.reject(error);
};

export default axios => {
  const { apiHost = '' } = window.dropechatConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  // Add Auth Headers to requests if logged in
  if (Auth.hasAuthCookie()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();
    Object.assign(wootApi.defaults.headers.common, {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    });
  }
  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => response,
    error => parseErrorCode(error)
  );
  return wootApi;
};
